import Model from '../utils/Model'

export default class SopDataItemTabConstants {
  constructor(code, englishName, chineseName, lob) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
    this.lob = lob
  }
}

/**
 * 数据服务
 * @type {SopDataItemTabConstants}
 */
export const SE_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'SE')
export const SE_VESSEL = new SopDataItemTabConstants(2, 'Booking page data', '订舱页数据', 'SE')
export const SE_CARGO_INFORMATION = new SopDataItemTabConstants(3, 'Cargo information', '货物信息', 'SE')
export const SE_FILE_INFORMATION = new SopDataItemTabConstants(4, 'File information', '文件信息', 'SE')
export const SE_GATE_DATA = new SopDataItemTabConstants(6, 'Gate data', '门点数据', 'SE')
export const SE_CUSTOMS = new SopDataItemTabConstants(5, 'customs clearance information', '报关数据', 'SE')
export const SE_MBL = new SopDataItemTabConstants(7, 'MB/L', 'MB/L', 'SE')
export const SE_HBL = new SopDataItemTabConstants(9, 'HB/L', 'HB/L', 'SE')
export const SE_AMS = new SopDataItemTabConstants(8, 'Anti-terrorism manifest', '反恐舱单', 'SE')
export const SE_SPECIAL_CARGO = new SopDataItemTabConstants(10, 'Special cargo', '特殊货物', 'SE')

export const SOP_DATA_ITEM_TABS = [SE_BASIC, SE_VESSEL, SE_MBL, SE_HBL, SE_CARGO_INFORMATION, SE_GATE_DATA, SE_CUSTOMS, SE_AMS, SE_SPECIAL_CARGO]

// IE
export const IE_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'IE')
export const SOP_DATA_ITEM_TABS_IE = [IE_BASIC]

// RI
export const RI_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'RI')
export const RI_FILE_INFORMATION = new SopDataItemTabConstants(6, 'Gate data', '门点数据', 'RI')
export const SOP_DATA_ITEM_TABS_RI = [RI_BASIC, RI_FILE_INFORMATION]

// RE
export const RE_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'RE')
export const RE_FILE_INFORMATION = new SopDataItemTabConstants(6, 'Gate data', '门点数据', 'RE')
export const SOP_DATA_ITEM_TABS_RE = [RE_BASIC, RE_FILE_INFORMATION]

// AI
export const AI_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'AI')
export const SOP_DATA_ITEM_TABS_AI = [AI_BASIC]

// AE
export const AE_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'AE')
export const AE_VESSEL = new SopDataItemTabConstants(2, 'Booking page data', '订舱数据', 'AE')
export const SOP_DATA_ITEM_TABS_AE = [AE_BASIC, AE_VESSEL]

// SI
export const SI_BASIC = new SopDataItemTabConstants(1, 'BasicData', '基础数据', 'SI')
export const SI_ARRIVAL_DATA = new SopDataItemTabConstants(5, 'Arrival data', '到港数据', 'SI')
export const SOP_DATA_ITEM_TABS_SI = [SI_BASIC, SI_ARRIVAL_DATA]

/**
 *  return null:没找到.
 */
export function getDataServiceByCode(code) {
  return Model.getObjByCode(code, SOP_DATA_ITEM_TABS)
}
